import React, { useState } from 'react'
import { Card, Form, Button, Alert } from 'react-bootstrap'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../firebase-config'
import { useNavigate } from "react-router";

export default function Login() {
    const navigate = useNavigate();

    const [user, setUser] = useState();
    const [show, setShow] = useState(true);
    const [errorMessages, setErrorMessages] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        var { email, password } = document.forms[0];

        try {
            const user = await signInWithEmailAndPassword(auth, email.value, password.value)
            setErrorMessages('');
            setUser(user);
            email.value = null;
            password.value = null;
            navigate('/dashboard', { replace: false });
        } catch (error) {
            password.value = null;
            setErrorMessages("Invalid Credentials!!");
            // console.log(error.message)
        }
    }

  return (
    <div className='container'>
        <div className='row pt-3'>
            <div className='col-md-4 offset-4'>
            {!user?.email &&
                <Card>
                    <Card.Body className="form">
                    {(errorMessages && show) &&
                        <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                            {errorMessages}
                        </Alert>
                    }
                        <h3>Login New User</h3>
                        <hr/>
                        <form onSubmit={handleSubmit}>
                            <Form.Floating className="mb-3">
                                <Form.Control
                                    id="floatingInputCustom"
                                    type="text"
                                    name="email"
                                    placeholder="name@example.com"
                                />
                                <label htmlFor="floatingInputCustom">Email address</label>
                            </Form.Floating>
                            <Form.Floating>
                                <Form.Control
                                    id="floatingPasswordCustom"
                                    type="password"
                                    placeholder="Password"
                                    name="password"
                                />
                                <label htmlFor="floatingPasswordCustom">Password</label>
                            </Form.Floating>
                            <div className="d-grid gap-2 mt-2">
                                <Button variant="primary" size="lg" type="submit">
                                   Login
                                </Button>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            }
            </div>
        </div>
    </div>
  )
}
